import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { CompanyUser } from '@models/User';
import { API_V1_BASE } from '@config';

export class UserApi {
  static getAllCompanyUsers = async () => {
    return await authAxios.get(`${API_V1_BASE}/company_users`).then((response) => humps(response.data) as CompanyUser[]);
  };
}
